module.exports = __webpack_public_path__ + "static/nicholas-begovich-e5f0c58af6eca2806a38209123b00965.jpg";